import React from "react";
import { useTranslation } from "react-i18next";

import OpenButton from "../../../ui/components/OpenButton/OpenButton";

import ArtifactFilesUploadForm from "./ArtifactFilesUploadForm";

export default function ArtifactFilesUploadButton({
	work,
	article,
	producer,
	publisher,
	production,
	onSuccess,
	...props
}) {
	const { t } = useTranslation();

	return (
		<OpenButton text={t("uploadFiles", "Upload files")} {...props}>
			{({ setOpen }) => (
				<ArtifactFilesUploadForm
					work={work}
					article={article}
					producer={producer}
					publisher={publisher}
					production={production}
					defaultName={article?.name || production?.title || work?.name}
					onSuccess={onSuccess}
					onClose={() => setOpen(false)}
				/>
			)}
		</OpenButton>
	);
}
